// DLocal 渠道专属参数覆盖、描述、示例
// 选中 DLOCAL 渠道时覆盖通用定义，仅当 selectedChannel === 'DLOCAL' 时生效。

export const DLOCAL_PARAM_OVERRIDES = {
  USER_CREATE: {
    request: [
      { name: 'requestId', label: '请求ID', type: 'STRING', required: true, maxLen: 64 },
      { name: 'channelCode', label: '渠道代码', type: 'ENUM', required: true, tip: 'DLOCAL' },
      { name: 'externalUserId', label: '外部用户ID', type: 'STRING', required: true, maxLen: 64 },
      { name: 'userType', label: '用户类型', type: 'ENUM', required: true, tip: 'INDIVIDUAL / BUSINESS' },
      { name: 'operateType', label: '操作类型', type: 'ENUM', required: true, tip: 'CREATE(首次) / UPDATE(补件)' },
      { name: 'currency', label: '币种', type: 'STRING', required: false, tip: 'DLocal 仅 BRL' },
      { name: 'callbackUrl', label: '回调地址', type: 'STRING', required: false, tip: '用户状态变更回调地址' },
      {
        name: 'extParam', label: '扩展参数', type: 'JSON_STRING', required: true, tip: '必填，JSON 格式字符串；含用户 KYC 信息及附件',
        children: [
          { name: 'fullName', label: '全名', type: 'STRING', required: true, tip: '收款人/企业全名' },
          { name: 'email', label: '邮箱', type: 'STRING', required: true },
          { name: 'country', label: '国家码', type: 'STRING', required: true, tip: 'ISO2 国家码，固定 BR' },
          { name: 'phone', label: '手机号', type: 'STRING', required: true },
          { name: 'taxId', label: '税号', type: 'STRING', required: true, tip: 'CPF(11位) 或 CNPJ(14位)' },
          { name: 'documentType', label: '证件类型', type: 'STRING', required: false, tip: 'CPF / CNPJ / PASSPORT / ID_CARD，可选' },
          { name: 'documentNumber', label: '证件号', type: 'STRING', required: false },
          {
            name: 'address', label: '地址', type: 'OBJECT', required: true,
            children: [
              { name: 'country', label: '国家', type: 'STRING', required: true },
              { name: 'city', label: '城市', type: 'STRING', required: true },
              { name: 'zipCode', label: '邮编', type: 'STRING', required: true },
              { name: 'street', label: '街道', type: 'STRING', required: true },
            ],
          },
          { name: 'attachments', label: '附件列表', type: 'ARRAY', required: false, tip: 'CREATE 必填，UPDATE(补件)可不传。每项含 fileId+fileType，先调文件上传接口获取 fileId。CREATE 时必须覆盖必传类型: INDIVIDUAL必传 ID_FRONT+ID_BACK(可选SELFIE/PROOF_OF_ADDRESS); BUSINESS必传 COMPANY_PROOF+LEGAL_REPRESENTATIVE_ID_FRONT/BACK+UBO_ID_FRONT/BACK(可选DIRECTOR_ID_FRONT/BACK/DIRECTOR_PROOF_OF_ADDRESS/LEGAL_REPRESENTATIVE_PROOF_OF_ADDRESS/UBO_PROOF_OF_ADDRESS/BANK_STATEMENT)。校验附件归属，防引用别人的文件' },
          { name: 'individualInfo.biometricResult', label: '生物识别结果', type: 'BOOLEAN', required: false, tip: 'INDIVIDUAL 可选' },
          { name: 'companyInfo.website', label: '企业网站', type: 'STRING', required: false, tip: 'BUSINESS 必填' },
          { name: 'companyInfo.documentExpeditionDate', label: '文件签发日期', type: 'STRING', required: false, tip: 'yyyy-MM-dd' },
          { name: 'companyInfo.registeredName', label: '注册名称', type: 'STRING', required: false },
          { name: 'companyInfo.establishDate', label: '成立日期', type: 'STRING', required: false, tip: 'yyyy-MM-dd' },
          { name: 'companyInfo.annualSalesInUsd', label: '年销售额(USD)', type: 'STRING', required: false },
          { name: 'companyInfo.legalRepresentatives', label: '法人代表列表', type: 'ARRAY', required: false, tip: 'BUSINESS 必填，法人代表列表，每项需 taxId' },
          { name: 'companyInfo.uboList', label: 'UBO列表', type: 'ARRAY', required: false, tip: 'BUSINESS 必填，UBO 列表，每项需 taxId' },
          { name: 'companyInfo.industryCode', label: '行业代码', type: 'STRING', required: false },
          { name: 'companyInfo.isSo', label: '是否SO', type: 'BOOLEAN', required: false },
          { name: 'companyInfo.isPep', label: '是否PEP', type: 'BOOLEAN', required: false, tip: '政治公众人物' },
        ],
      },
    ],
    response: [
      { name: 'userId', label: '用户ID', type: 'STRING', required: true },
      { name: 'channelUserId', label: '渠道用户ID', type: 'STRING', required: false },
      { name: 'externalUserId', label: '外部用户ID', type: 'STRING', required: false },
      { name: 'status', label: '状态', type: 'STRING', required: true, tip: 'PROCESSING / SUCCESS / FAILED / WAITING_SUPPLEMENT' },
      { name: 'failedReason', label: '失败原因', type: 'STRING', required: false },
      { name: 'requiredFields', label: '需补字段', type: 'ARRAY', required: false, tip: 'WAITING_SUPPLEMENT 时返回，type(field/document) + name 对' },
      { name: 'extParams', label: '扩展参数', type: 'STRING', required: false, tip: 'JSON 字符串，开户成功后返回 pixKey' },
    ],
  },
  USER_QUERY: {
    request: [
      { name: 'requestId', label: '请求ID', type: 'STRING', required: true, maxLen: 64 },
      { name: 'channelCode', label: '渠道代码', type: 'ENUM', required: true, tip: 'DLOCAL' },
      { name: 'externalUserId', label: '外部用户ID', type: 'STRING', required: false, tip: 'externalUserId 或 userId 二选一' },
      { name: 'userId', label: '用户ID', type: 'STRING', required: false, tip: 'externalUserId 或 userId 二选一' },
    ],
    response: [
      { name: 'userId', label: '用户ID', type: 'STRING', required: true },
      { name: 'externalUserId', label: '外部用户ID', type: 'STRING', required: true },
      { name: 'status', label: '状态', type: 'STRING', required: true, tip: 'PROCESSING / SUCCESS / FAILED / WAITING_SUPPLEMENT' },
      { name: 'channelUserId', label: '渠道用户ID', type: 'STRING', required: false },
      { name: 'failedReason', label: '失败原因', type: 'STRING', required: false },
      { name: 'requiredFields', label: '需补字段', type: 'ARRAY', required: false, tip: 'WAITING_SUPPLEMENT 时返回，type(field/document) + name 对' },
      {
        name: 'extParams', label: '扩展参数', type: 'STRING', required: false, tip: 'JSON 字符串，开户成功后返回 pixKey',
        children: [
          { name: 'pixKey', label: 'PIX Key', type: 'STRING', required: false, tip: '开户审批通过后返回的 PIX Key' },
        ],
      },
    ],
  },
  DEPOSIT_CREATE: {
    request: [
      { name: 'requestId', label: '请求ID', type: 'STRING', required: true, maxLen: 64 },
      { name: 'channelCode', label: '渠道代码', type: 'ENUM', required: true, tip: 'DLOCAL' },
      { name: 'externalUserId', label: '外部用户ID', type: 'STRING', required: true, maxLen: 64 },
      { name: 'externalOrderId', label: '外部订单号', type: 'STRING', required: true, maxLen: 256, tip: '幂等 key' },
      { name: 'currency', label: '币种', type: 'ENUM', required: true, tip: '仅支持 BRL' },
      { name: 'amount', label: '金额', type: 'DECIMAL', required: true },
      { name: 'depositMethod', label: '充值方式', type: 'ENUM', required: true, tip: '仅 PIX' },
      { name: 'callbackUrl', label: '回调地址', type: 'STRING', required: false, maxLen: 2048, tip: '回调通知地址' },
      { name: 'accountId', label: '账户ID', type: 'STRING', required: false, tip: 'split payment 场景传入' },
      {
        name: 'extParam', label: '扩展参数', type: 'JSON_STRING', required: true, tip: '必填，JSON 格式字符串，含付款方信息',
        children: [
          { name: 'payerName', label: '付款方姓名', type: 'STRING', required: true, maxLen: 100, tip: '付款方姓名' },
          { name: 'payerEmail', label: '付款方邮箱', type: 'STRING', required: true, maxLen: 100 },
          { name: 'payerDocumentNumber', label: '付款方证件号', type: 'STRING', required: true, maxLen: 30, tip: 'CPF(11位)/CNPJ(14位)' },
          { name: 'description', label: '描述', type: 'STRING', required: false, maxLen: 200, tip: 'sandbox 可用 "200" 模拟成功' },
          { name: 'payerDocumentType', label: '证件类型', type: 'STRING', required: false, tip: 'CPF / CNPJ' },
          { name: 'payerPhone', label: '付款方手机', type: 'STRING', required: false },
          { name: 'payerUserReference', label: '付款方用户标识', type: 'STRING', required: false, tip: '商户侧唯一ID，风控用' },
          { name: 'payerBirthDate', label: '出生日期', type: 'STRING', required: false, tip: '格式 DD-MM-YYYY' },
          { name: 'payerIp', label: '付款方IP', type: 'STRING', required: false },
        ],
      },
    ],
    response: [
      { name: 'orderId', label: '订单号', type: 'STRING', required: true },
      { name: 'status', label: '状态', type: 'STRING', required: true, tip: 'PROCESSING' },
      { name: 'externalOrderId', label: '外部订单号', type: 'STRING', required: true },
    ],
  },
  DEPOSIT_QUERY: {
    response: [
      { name: 'orderId', label: '订单号', type: 'STRING', required: true },
      { name: 'status', label: '状态', type: 'STRING', required: true, tip: 'PROCESSING / SUCCESS / FAILED' },
      { name: 'subStatus', label: '子状态', type: 'STRING', required: false, tip: 'SUCCESS / FAILED' },
      { name: 'externalOrderId', label: '外部订单号', type: 'STRING', required: true },
      { name: 'channelOrderId', label: '渠道订单号', type: 'STRING', required: false },
      { name: 'accountId', label: '账户ID', type: 'STRING', required: false },
      { name: 'amount', label: '金额', type: 'STRING', required: true },
      { name: 'currency', label: '币种', type: 'STRING', required: true },
      { name: 'channelCode', label: '渠道', type: 'STRING', required: true },
      { name: 'depositMethod', label: '充值方式', type: 'STRING', required: false, tip: 'PIX' },
      { name: 'fee', label: '手续费', type: 'STRING', required: false },
      { name: 'errorCode', label: '错误码', type: 'STRING', required: false },
      { name: 'errorMsg', label: '错误信息', type: 'STRING', required: false },
      { name: 'refundStatus', label: '退款状态', type: 'STRING', required: false, tip: 'NOT_REFUNDED / REFUNDED / PARTIAL_REFUNDED' },
      { name: 'remark', label: '备注', type: 'STRING', required: false },
      { name: 'createTime', label: '创建时间', type: 'STRING', required: true },
      { name: 'updateTime', label: '更新时间', type: 'STRING', required: false },
      { name: 'completedTime', label: '完成时间', type: 'STRING', required: false },
      {
        name: 'paymentInfo', label: '支付信息', type: 'OBJECT', required: false, tip: 'PIX 支付信息',
        children: [
          { name: 'payType', label: '支付类型', type: 'STRING', required: false, tip: 'QR_CODE / REDIRECT' },
          { name: 'payUrl', label: '支付链接', type: 'STRING', required: false, tip: 'PIX 支付页面链接' },
          { name: 'qrCode', label: 'QR码图片', type: 'STRING', required: false, tip: 'base64 QR图片' },
          { name: 'number', label: 'PIX码', type: 'STRING', required: false, tip: 'PIX copy-paste码(ticket number)' },
        ],
      },
      {
        name: 'senderInfo', label: '付款方信息', type: 'OBJECT', required: false,
        children: [
          { name: 'senderAcctName', label: '付款方姓名', type: 'STRING', required: false },
          { name: 'senderDocumentNumber', label: '付款方证件号', type: 'STRING', required: false },
          { name: 'senderDocumentType', label: '付款方证件类型', type: 'STRING', required: false, tip: 'CPF / CNPJ' },
        ],
      },
    ],
  },
  WITHDRAW_CREATE: {
    request: [
      { name: 'requestId', label: '请求ID', type: 'STRING', required: true, maxLen: 64 },
      { name: 'channelCode', label: '渠道代码', type: 'ENUM', required: true, tip: 'DLOCAL' },
      { name: 'externalUserId', label: '外部用户ID', type: 'STRING', required: true, maxLen: 64 },
      { name: 'externalOrderId', label: '外部订单号', type: 'STRING', required: true, maxLen: 256, tip: '幂等 key' },
      { name: 'currency', label: '币种', type: 'ENUM', required: true, tip: '仅支持 BRL' },
      { name: 'amount', label: '金额', type: 'DECIMAL', required: true, tip: '正数，最多2位小数' },
      { name: 'withdrawMethod', label: '提现方式', type: 'ENUM', required: true, tip: '仅 PIX' },
      { name: 'callbackUrl', label: '回调地址', type: 'STRING', required: true, maxLen: 2048, tip: '必须以 http:// 或 https:// 开头' },
      { name: 'accountId', label: 'Account ID', type: 'STRING', required: false, maxLen: 64, tip: 'POBO transfer' },
      {
        name: 'extParam', label: '扩展参数', type: 'JSON_STRING', required: true, tip: '必填，JSON 格式字符串，含 PIX 提现信息',
        children: [
          // ── Required ──
          { name: 'pixKey', label: 'PIX Key', type: 'STRING', required: true, tip: 'CPF/CNPJ/邮箱/手机/EVP 格式的 PIX Key' },
          { name: 'flowType', label: '流水类型', type: 'ENUM', required: true, tip: 'B2B(企业对企业) / P2P(个人对个人) / B2C(企业对个人)' },
          { name: 'purpose', label: '用途码', type: 'ENUM', required: true, tip: '30种用途码; 常用: PAYROLL(工资)/SUPPLIER(供应商)/UTILITY_PROVIDER(水电费)/TAXES(税费)/INVESTMENT(投资)/PROPERTY_RENTAL(租金)/INSURANCE(保险)/REMITTANCES(汇款)' },
          { name: 'receiverDocumentNumber', label: '收款方证件号', type: 'STRING', required: true, tip: 'CPF(11位)/CNPJ(14位)' },
          { name: 'senderFirstName', label: '汇款方名', type: 'STRING', required: false, tip: 'B2B/P2P 必填，B2C 不需要' },
          { name: 'senderLastName', label: '汇款方姓', type: 'STRING', required: false, tip: 'B2B/P2P 必填，B2C 不需要' },
          { name: 'senderDocumentNumber', label: '汇款方证件号', type: 'STRING', required: false, tip: 'B2B/P2P 必填，B2C 不需要' },
          // ── Conditional required ──
          { name: 'receiverBusinessName', label: '收款企业名', type: 'STRING', required: false, tip: 'B2B 时必填' },
          { name: 'receiverFirstName', label: '收款方名', type: 'STRING', required: false, tip: 'P2P/B2C 时必填' },
          { name: 'receiverLastName', label: '收款方姓', type: 'STRING', required: false, tip: 'P2P/B2C 时必填' },
          // ── Transaction ──
          { name: 'description', label: '描述', type: 'STRING', required: false, maxLen: 200 },
          // ── Receiver basic info ──
          { name: 'receiverDocumentType', label: '收款方证件类型', type: 'STRING', required: false, tip: 'CPF / CNPJ; P2P 同证件号时必填' },
          { name: 'receiverPhone', label: '收款方手机', type: 'STRING', required: false },
          { name: 'receiverEmail', label: '收款方邮箱', type: 'STRING', required: false },
          { name: 'receiverBirthDate', label: '收款方出生日期', type: 'STRING', required: false },
          { name: 'receiverBirthCountry', label: '收款方出生国家', type: 'STRING', required: false },
          { name: 'receiverBirthCity', label: '收款方出生城市', type: 'STRING', required: false },
          // ── Receiver address ──
          { name: 'receiverStreet', label: '收款方街道', type: 'STRING', required: false, tip: 'P2P 同证件号时必填' },
          { name: 'receiverAddressNumber', label: '收款方门牌号', type: 'STRING', required: false },
          { name: 'receiverCity', label: '收款方城市', type: 'STRING', required: false, tip: 'P2P 同证件号时必填' },
          { name: 'receiverState', label: '收款方州', type: 'STRING', required: false },
          { name: 'receiverCountry', label: '收款方国家', type: 'STRING', required: false },
          { name: 'receiverPostalCode', label: '收款方邮编', type: 'STRING', required: false },
          // ── Sender basic info ──
          { name: 'senderDocumentType', label: '汇款方证件类型', type: 'STRING', required: false },
          { name: 'senderDocumentIssueDate', label: '汇款方证件签发日期', type: 'STRING', required: false },
          { name: 'senderDocumentExpirationDate', label: '汇款方证件到期日期', type: 'STRING', required: false },
          { name: 'senderNationality', label: '汇款方国籍', type: 'STRING', required: false },
          { name: 'senderPhone', label: '汇款方手机', type: 'STRING', required: false },
          { name: 'senderEmail', label: '汇款方邮箱', type: 'STRING', required: false },
          { name: 'senderFundsSource', label: '汇款方资金来源', type: 'STRING', required: false },
          { name: 'senderBirthDate', label: '汇款方出生日期', type: 'STRING', required: false },
          { name: 'senderBirthCountry', label: '汇款方出生国家', type: 'STRING', required: false },
          { name: 'senderBirthCity', label: '汇款方出生城市', type: 'STRING', required: false },
          { name: 'senderCountry', label: '汇款方国家', type: 'STRING', required: false, tip: 'P2P 同证件号时必填' },
          // ── Sender address ──
          { name: 'senderStreet', label: '汇款方街道', type: 'STRING', required: false },
          { name: 'senderAddressNumber', label: '汇款方门牌号', type: 'STRING', required: false },
          { name: 'senderCity', label: '汇款方城市', type: 'STRING', required: false },
          { name: 'senderState', label: '汇款方州', type: 'STRING', required: false },
          { name: 'senderPostalCode', label: '汇款方邮编', type: 'STRING', required: false },
        ],
      },
    ],
    response: [
      { name: 'orderId', label: '订单号', type: 'STRING', required: true },
      { name: 'status', label: '状态', type: 'STRING', required: true, tip: 'PROCESSING（异步处理，最终状态通过 webhook 回调）' },
    ],
  },
  WITHDRAW_QUERY: {
    response: [
      { name: 'orderId', label: '订单号', type: 'STRING', required: true },
      { name: 'status', label: '状态', type: 'STRING', required: true, tip: 'PROCESSING / SUCCESS / FAILED' },
      { name: 'subStatus', label: '子状态', type: 'STRING', required: false, tip: 'SUCCESS / FAILED' },
      { name: 'externalOrderId', label: '外部订单号', type: 'STRING', required: true },
      { name: 'channelOrderId', label: '渠道订单号', type: 'STRING', required: false },
      { name: 'accountId', label: '账户ID', type: 'STRING', required: false },
      { name: 'amount', label: '金额', type: 'STRING', required: true },
      { name: 'currency', label: '币种', type: 'STRING', required: true },
      { name: 'channelCode', label: '渠道', type: 'STRING', required: true },
      { name: 'withdrawMethod', label: '提现方式', type: 'STRING', required: false, tip: 'PIX' },
      { name: 'fee', label: '手续费', type: 'STRING', required: false },
      { name: 'errorCode', label: '错误码', type: 'STRING', required: false },
      { name: 'errorMsg', label: '错误信息', type: 'STRING', required: false },
      { name: 'createTime', label: '创建时间', type: 'STRING', required: true },
      { name: 'updateTime', label: '更新时间', type: 'STRING', required: false },
      { name: 'completedTime', label: '完成时间', type: 'STRING', required: false },
      { name: 'externalUserId', label: '外部用户ID', type: 'STRING', required: false },
      {
        name: 'senderInfo', label: '汇款方信息', type: 'OBJECT', required: false,
        children: [
          { name: 'accountName', label: '姓名', type: 'STRING', required: false },
          { name: 'documentId', label: '证件号', type: 'STRING', required: false },
          { name: 'documentType', label: '证件类型', type: 'STRING', required: false, tip: 'CPF / CNPJ' },
          { name: 'network', label: '网络', type: 'STRING', required: false, tip: 'PIX' },
        ],
      },
      {
        name: 'receiverInfo', label: '收款方信息', type: 'OBJECT', required: false,
        children: [
          { name: 'accountName', label: '姓名', type: 'STRING', required: false },
          { name: 'documentId', label: '证件号', type: 'STRING', required: false },
          { name: 'documentType', label: '证件类型', type: 'STRING', required: false, tip: 'CPF / CNPJ' },
          { name: 'network', label: '网络', type: 'STRING', required: false, tip: 'PIX' },
        ],
      },
    ],
  },
  BALANCE_QUERY: {
    request: [
      { name: 'requestId', label: '请求ID', type: 'STRING', required: true },
      { name: 'channelCode', label: '渠道代码', type: 'ENUM', required: true, tip: 'DLOCAL' },
      { name: 'externalUserId', label: '外部用户ID', type: 'STRING', required: true, tip: 'DLocal 通过 externalUserId 定位子账户查余额' },
      { name: 'currency', label: '币种', type: 'STRING', required: true, tip: '仅支持 BRL' },
    ],
    response: [
      { name: 'channelAccountNo', label: '渠道账户号', type: 'STRING', required: true },
      { name: 'channelCode', label: '渠道编码', type: 'STRING', required: true },
      { name: 'currency', label: '币种', type: 'STRING', required: true },
      { name: 'availableBalance', label: '可用余额', type: 'STRING', required: true },
      {
        name: 'balanceDetails', label: '余额明细', type: 'ARRAY', required: false, tip: '多维度余额明细，DLocal 返回 current_balance / available_for_withdrawals / payins_in_transit',
        children: [
          { name: 'type', label: '余额类型', type: 'STRING', required: false, tip: 'current_balance / available_for_withdrawals / payins_in_transit' },
          { name: 'amount', label: '金额', type: 'STRING', required: false },
        ],
      },
    ],
  },
};

export const DLOCAL_API_DESC = {
  USER_CREATE: '创建 DLocal 用户（KYC/KYB），异步处理。支持 INDIVIDUAL/BUSINESS 两种类型，需上传身份证件附件。',
  USER_QUERY: '查询 DLocal 用户状态和详情，注册成功后可获取 PIX Key。',
  DEPOSIT_CREATE: '创建 DLocal PIX 充值订单，返回 PIX QR 码供付款方扫码支付。仅支持 BRL。',
  DEPOSIT_QUERY: '查询 DLocal 充值订单状态。',
  WITHDRAW_CREATE: '从 DLocal 账户发起 PIX 提现，支持 B2B/P2P 两种 flowType，需指定 purpose 用途码。用户须已注册成功。',
  WITHDRAW_QUERY: '查询 DLocal 提现订单状态。',
  BALANCE_QUERY: '查询 DLocal 渠道账户余额，仅 BRL。返回 available 和 current balance。',
};

export const DLOCAL_API_EXAMPLES = {
  USER_CREATE: {
    request: {
      requestId: 'REQ-DL-USER-001',
      channelCode: 'DLOCAL',
      externalUserId: 'user-br-001',
      userType: 'INDIVIDUAL',
      operateType: 'CREATE',
      extParam: '{"fullName":"João Silva","email":"joao@example.com","country":"BR","phone":"+5511999990001","taxId":"12345678901","address":{"country":"BR","city":"São Paulo","zipCode":"01310-100","street":"Av Paulista 1000"},"attachments":[{"fileId":"FILE001","fileType":"ID_FRONT"},{"fileId":"FILE002","fileType":"ID_BACK"}],"individualInfo":{"biometricResult":true}}',
    },
    response: {
      code: 200, subCode: '000000', msg: 'Success', requestId: 'REQ-DL-USER-001',
      data: { userId: 'UR20260910DL00000001', status: 'PROCESSING' },
    },
  },
  USER_QUERY: {
    request: { requestId: 'REQ-DL-UQ-001', channelCode: 'DLOCAL', externalUserId: 'user-br-001' },
    response: {
      code: 200, subCode: '000000', msg: 'Success', requestId: 'REQ-DL-UQ-001',
      data: {
        userId: 'UR20260910DL00000001', externalUserId: 'user-br-001', status: 'SUCCESS',
        channelCode: 'DLOCAL', userType: 'INDIVIDUAL',
        extParam: { pixKey: '123e4567-e89b-12d3-a456-426614174000' },
      },
    },
  },
  DEPOSIT_CREATE: {
    request: {
      requestId: 'REQ-DL-DEP-001',
      channelCode: 'DLOCAL',
      externalUserId: 'user-br-001',
      externalOrderId: 'EXT-DEP-20260910-001',
      currency: 'BRL',
      amount: '100.00',
      depositMethod: 'PIX',
      callbackUrl: 'https://merchant.com/callback',
      extParam: '{"payerName":"João Silva","payerEmail":"joao@example.com","payerDocumentNumber":"12345678901"}',
    },
    response: {
      code: 200, subCode: '000000', msg: 'Success', requestId: 'REQ-DL-DEP-001',
      data: {
        orderId: 'DP20260910DL00000001', status: 'PROCESSING', externalOrderId: 'EXT-DEP-20260910-001',
        paymentInfo: {
          qrCode: '00020126580014br.gov.bcb.pix0136123e4567-e89b-12d3-a456-426614174000',
          qrCodeImage: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUg...',
          expirationDate: '2026-09-10T15:10:00Z',
        },
      },
    },
  },
  DEPOSIT_QUERY: {
    request: { requestId: 'REQ-DL-DQ-001', orderId: 'DP20260910DL00000001' },
    response: {
      code: 200, subCode: '000000', msg: 'Success', requestId: 'REQ-DL-DQ-001',
      data: {
        orderId: 'DP20260910DL00000001', status: 'SUCCESS', externalOrderId: 'EXT-DEP-20260910-001',
        amount: '100.00', currency: 'BRL', channelCode: 'DLOCAL',
        createTime: '1725969000000', updateTime: '1725969060000',
        paymentInfo: {
          qrCode: '00020126580014br.gov.bcb.pix0136123e4567-e89b-12d3-a456-426614174000',
          qrCodeImage: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUg...',
          expirationDate: '2026-09-10T15:10:00Z',
        },
      },
    },
  },
  WITHDRAW_CREATE: {
    request: {
      requestId: 'REQ-DL-WD-001',
      channelCode: 'DLOCAL',
      externalUserId: 'user-br-001',
      externalOrderId: 'EXT-WD-20260910-001',
      currency: 'BRL',
      amount: '500.00',
      withdrawMethod: 'PIX',
      callbackUrl: 'https://merchant.com/callback',
      extParam: '{"pixKey":"123e4567-e89b-12d3-a456-426614174000","flowType":"P2P","purpose":"REMITTANCES","receiverDocumentNumber":"98765432100","receiverFirstName":"Maria","receiverLastName":"Santos","senderFirstName":"João","senderLastName":"Silva","senderDocumentNumber":"12345678901"}',
    },
    response: {
      code: 200, subCode: '000000', msg: 'Success', requestId: 'REQ-DL-WD-001',
      data: { orderId: 'WD20260910DL00000001', status: 'PROCESSING' },
    },
  },
  WITHDRAW_QUERY: {
    request: { requestId: 'REQ-DL-WQ-001', orderId: 'WD20260910DL00000001' },
    response: {
      code: 200, subCode: '000000', msg: 'Success', requestId: 'REQ-DL-WQ-001',
      data: {
        orderId: 'WD20260910DL00000001', status: 'SUCCESS', externalOrderId: 'EXT-WD-20260910-001',
        amount: '500.00', currency: 'BRL', channelCode: 'DLOCAL',
        fee: '5.00', createTime: '1725969000000', updateTime: '1725969060000',
      },
    },
  },
  BALANCE_QUERY: {
    request: { requestId: 'REQ-DL-BAL-001', channelCode: 'DLOCAL', currency: 'BRL' },
    response: {
      code: 200, subCode: '000000', msg: 'Success', requestId: 'REQ-DL-BAL-001',
      data: { channelAccountNo: 'LA20260910DL00000001', channelCode: 'DLOCAL', currency: 'BRL', availableBalance: '10000.00', currentBalance: '12500.00' },
    },
  },
};
